import React, { useCallback, useRef, useState } from 'react';
import config from './calculateFormulaList.json';
import { message, Drawer, Space, Button } from 'antd';
import { SLowcodeList} from 'shj-components'
import { isNil } from 'lodash-es';
import { calculationFormulaSearch, receiptRuleState } from '@/services/integrationConfig'
interface dataProps {
  open: boolean;
  showMode?: 'drawer' | 'modal'; //呈现方式
  config: any;
  type?: 'radio' | 'checkbox'; //多选/单选
  selectedRowKeys?: any[]; //回显的key
  selectedRow?: any[]; //回显的行数据(row)
  title?: string | JSX.Element;
  width?: number;
  mask?: boolean; //是否展示遮罩
  maskClosable?: boolean; //点击蒙层是否允许关闭
  onOk: (rows?: any) => void; //点击确定回调
  onCancel: () => void; //点击遮罩层或右上角叉或取消按钮的回调 modal
}
/**
 * 是否为有效的数组
 * @param arr 数组
 */
const isValidArray = (arr: any[]) => {
  return arr && Array.isArray(arr) && arr.length > 0 ? true : false;
};
const OtherRules: React.FC<dataProps> = (props) => {
  const { open, showMode = 'drawer', type = 'radio', title, width, onOk, onCancel } = props;
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const data = await calculationFormulaSearch(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusList: [
          {
            key: true,
            title: '启用',
          },
          {
            key: false,
            title: '禁用',
          },
        ],
      });
    });
  };

  const onEdit = (record: any) => {
    console.log(record);
    add(record);
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const edit = (obj: object) => {
    // add(obj);
  };
  const onSave = useCallback((values, dialogDestroy) => {}, []);
  const onAdd = useCallback(() => {
    add();
  }, [onSave]);
  const onDisable = useCallback(({ record, rows, selectedRows } = {}) => {
    const list = [];
    for (let m of selectedRows) {
      list.push(m.id);
    }
    receiptRuleState({ ids: list, state: 2 })
      .then((response: any) => {
        message.success(response?.message);
        reloadFn();
      });
  }, []);

  const _onOk = () => {
    if (isNil(listRef?.current?.getSelectedRows())) {
      message.warning('请选择数据');
      return;
    }
    const [_selectedRowKeys, selectedRows] = listRef?.current?.getSelectedRows && listRef?.current?.getSelectedRows();
    if (!isValidArray(selectedRows)) {
      message.warning('请选择数据');
      return;
    }
    onOk && onOk(selectedRows);
  };

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onDisable },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell(text: any) {
        return text ? '启用' : '禁用';
      },
    },
  };
  return (
    <Drawer
      visible={open}
      title={title || '数据选择'}
      width={width || 860}
      onClose={onCancel}
      extra={
        <Space>
          <Button onClick={onCancel}>关闭</Button>
          <Button onClick={() => _onOk()} type="primary">
            确定
          </Button>
        </Space>
      }
    >
      <SLowcodeList
        config={{ ...config, tableType: 'antd', rowSelectionType: 'radio' }}
        ref={listRef}
        {...extension}
      />
    </Drawer>
  );
};
export default OtherRules;
